// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".closeBtn[data-v-a6c9f914]{cursor:pointer}.actionBackgroundGray[data-v-a6c9f914]{background-color:hsla(0,0%,66.3%,.1)}.action-wrapper[data-v-a6c9f914]{border-top:.1em dotted grey}.action-wrapper[data-v-a6c9f914] .v-btn{margin-bottom:8px;margin-right:0!important;margin-left:0!important}", ""]);
// Exports
module.exports = exports;
